import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import Document from './../../../../../../components/document';
import { getAdmin, setProgressionProperties } from '../../../../../../reducers/onboarding';
import { getSignatures, sign } from '../../../../../../reducers/signatures';
import Signature from '../../../../../../components/signature';
import { Signatures } from '../../../../../../utilities/signatureTypes';
import mixpanel from 'mixpanel-browser';
import { employeeHandBook } from '../../../../../../utilities/regime';

class EmployeeHandbookStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'employee', step: 'EmployeeHandbookStep' } });

        const { role, admin, client, job, getAdmin, getSignatures, setProgressionProperties } = this.props;
        getSignatures(role, signaturesResult =>
            setProgressionProperties({
                employeeHandbookAgreement: signaturesResult.find(s => s.name === `${Signatures.types.EMPLOYEE_HANDBOOK_AGREEMENT.name}:${job.id}`) !== undefined
            })
        );

        if (!admin) {
            getAdmin(client.admin_id);
        }
    }

    submit(values, action) {
        const { role, job, progression, sign, setProgressionProperties } = this.props;
        const { agreementBGfcra } = progression;
        if (agreementBGfcra === true) {
            action();
        } else {
            sign(role, `${Signatures.types.EMPLOYEE_HANDBOOK_AGREEMENT.name}:${job.id}`, () => {
                setProgressionProperties({ employeeHandbookAgreement: true });
                action();
            });
        }
    }

    render() {
        const { handleSubmit, onSubmit, back, submitting, admin, job, progression, regime } = this.props;
        if (!admin || !progression || progression.employeeHandbookAgreement === undefined) {
            return null;
        }

        return (
            <div>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'employeeHandbook.intro'}
                            defaultMessage="Please review the {admin} employee handbook."
                            values={{ admin: admin.name }}
                        />
                    </div>
                </div>
                <div className="row section">
                    <div className="col-xs-12">
                        <Document
                            {...employeeHandBook(regime)}
                            view={{ showHeader: false, component: 'icon-download' }}
                            ownerRole={{ id: admin.id, type: 'admin' }}
                        />
                    </div>
                </div>
                <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                    <div className="row">
                        <div className="col-xs-12">
                            <FormattedMessage {...messages.iAgreeToDocument} values={{ admin: admin.name }} />
                            <Signature name={`${Signatures.types.EMPLOYEE_HANDBOOK_AGREEMENT.name}:${job.id}`} />
                        </div>
                    </div>

                    <WizardButtons disabled={submitting} back={{ action: back }} submit={{ message: <FormattedMessage {...messages.signAndContinue} /> }} />
                </form>
            </div>
        );
    }
}

EmployeeHandbookStep = reduxForm(formSettings)(EmployeeHandbookStep);

const mapStateToProps = state => {
    let progression = state.onboarding.progression;
    return {
        role: state.identity.role,
        job: state.onboarding.job,
        admin: state.onboarding.admin,
        client: state.onboarding.client,
        regime: (state.jobs.list || [{}])[0].regime,
        progression,
        initialValues: {
            employeeHandbookAgreement: progression.employeeHandbookAgreement
        }
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin: getAdmin,
            getSignatures: getSignatures,
            sign: sign,
            setProgressionProperties: setProgressionProperties
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeHandbookStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/employeeHandbook.jsx